import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Reviews from "@/pages/Reviews";

export const Route = createFileRoute("/_site/reviews")({
  head: () => ({
    ...seo({
      title: "Leave a Review | Kodiak Structures & Exteriors",
      description:
        "Rate your experience with Kodiak Structures & Exteriors. Share a review or tell us how we can make it right.",
      path: "/reviews",
      noindex: true,
    }),
  }),
  component: Reviews,
});
